module.exports = __webpack_public_path__ + "img/img_vision_04.54ca394b.png";